import { useState } from "react";

import { Controller, UseControllerProps } from "react-hook-form";
import { StylesConfig } from "react-select";

import CreatableSelect from "react-select/creatable";

import { SCvalues } from "@/_helpers/commonComponentsTypes.ts";
import { ErrorForm } from "@/common/components/form/ErrorForm.tsx";
import {
  LabelForm,
  LabelFormProps,
} from "@/common/components/form/LabelForm.tsx";
import {
  arrayValueToString,
  stringToArrayValue,
} from "@/common/components/form/SelectCreatableForm.tsx";

const Styles: StylesConfig<SCvalues, true> = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#FAFAFA",
    borderColor: "#C5C5C5",
  }),
  container: (styles) => ({
    ...styles,
    width: "100%",
    minHeight: "38px",
  }),
  option: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: "#FAFAFA",
    color: "#000",
    cursor: isDisabled ? "not-allowed" : "default",
    ":hover": {
      ...styles[":active"],
      backgroundColor: "#641ABF",
      color: "#FFF",
    },
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 999999,
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#641ABF",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#FFF",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#FFF",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#6c757d",
  }),
};

const components = {
  DropdownIndicator: null,
};

interface Option {
  readonly label: string;
  readonly value: string;
}

type InputCreatableFormProps = {
  placeholder?: string;
  defaultValue?: Option[];
} & UseControllerProps &
  LabelFormProps;

export const InputCreatable = (props: InputCreatableFormProps) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (event: any, callback: (inputValue: any) => void) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        callback(inputValue);
    }
  };

  return (
    <div className="form-input">
      <LabelForm
        label={props.label}
        required={!!props.rules?.required}
        labelInfos={props.labelInfos}
      />
      <Controller
        control={props.control}
        name={props.name}
        defaultValue={props.defaultValue}
        render={({ field, fieldState }) => {
          return (
            <div className={"d-flex flex-column"}>
              <div
                className={
                  "d-flex justify-content-center align-items-center w-100 loader-height"
                }
              >
                <CreatableSelect
                  styles={Styles}
                  components={components}
                  inputValue={inputValue}
                  isClearable
                  isMulti
                  menuIsOpen={false}
                  onChange={(newValue) => {
                    field.onChange(
                      arrayValueToString(newValue as readonly Option[])
                    );
                  }}
                  onInputChange={(newValue) => setInputValue(newValue)}
                  onKeyDown={(event) => {
                    handleKeyDown(event, (inputValue: string) => {
                      const arrValue: string[] = field.value
                        ? field.value.split(",")
                        : [];
                      arrValue.push(inputValue);
                      setInputValue("");
                      field.onChange(arrValue.join(","));
                      event.preventDefault();
                    });
                  }}
                  defaultValue={stringToArrayValue(
                    field.value ?? props.defaultValue
                  )}
                  placeholder={props.placeholder ?? " "}
                  value={stringToArrayValue(field.value)}
                />
              </div>
              <ErrorForm error={fieldState.error} />
            </div>
          );
        }}
        rules={props.rules}
      />
    </div>
  );
};
